module.exports = __webpack_public_path__ + "img/banner02.e4fde251.webp";